import { createStore } from 'vuex'
import AuthService from './services/auth';
import appInfo from './app-info';

let userData = AuthService.getUser();

export default createStore({
  //namespaced: true,
  state: {
      user: userData.data,
      loggedIn: userData.isOk,
      permissions: userData.data.permissions,
      sites: userData.data.sites,
      timezone: '',
      localTimeOffset: 0,
      remoteTimeOffset:0
    },
  getters:{
    hasReadAccess: (state) => (permissionId) => {
      try{
        let permObj = state.permissions.find(psn => psn.code == permissionId)
        return [1,3,5,7].includes(permObj.value)
      }
      catch{ return false }
    },
    hasWriteAccess: (state) => (permissionId) => {
      try{
        let permObj = state.permissions.find(psn => psn.code == permissionId)
        return [2,3,6,7].includes(permObj.value)
      }
      catch{ return false }
    },
    hasEditAccess: (state) => (permissionId) => {
      try{
        let permObj = state.permissions.find(psn => psn.code == permissionId)
        return [4,5,6,7].includes(permObj.value)
      }
      catch{ return false }
    },
    hasAdminAccess: (state) => (permissionId) => {
      try{
        let permObj = state.permissions.find(psn => psn.code == permissionId)
        return [7].includes(permObj.value)
      }
      catch{ return false }
    }
  },
  actions: {
    logIn({ commit }, userData) {
      return AuthService.logIn(userData).then(
        payload => {
          commit('loginSuccess', payload);
          return Promise.resolve(payload);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logOut({ commit }) {
      AuthService.logOut();
      let userInfo = AuthService.getUser();
      commit('logout', userInfo);
    },
    validateLogin({ dispatch, state }) {
      if (!AuthService.loggedIn()){
        dispatch('logOut');
      }
      let expiryDate = state.user.expiryDate? state.user.expiryDate : new Date().getTime()/1000;
      let msToExpire = expiryDate - new Date().getTime()/1000;
      if (msToExpire==0){
        dispatch('logOut');
        return false
      }
      if (msToExpire < appInfo.secsToKA*1000){
        dispatch('keepAlive');
      }
      return this.state.loggedIn
    },
    keepAlive({ commit, state }) {
      if (this.state.loggedIn){
        console.log('Trying to send keepalive signal')
        AuthService.keepAlive( {sessionId: state.user.sessionId} )
        .then( payload => {
          commit('updateAuth', payload.data);
        },
        error => {
          //commit('loginFailure');
          return Promise.reject(error);
        })
      }
    },
    setTimezone({ commit }, timezone){
      const localDate = new Date();
      const remoteDate = new Date(localDate.toLocaleString('en-US',{timeZone:timezone}))
      const localOffset = -localDate.getTimezoneOffset()/60 
      const remoteOffset = remoteDate.getHours() - (localDate.getHours() - localOffset) -(localDate.getDay()-remoteDate.getDay())*24
      commit('uptateTimezone', {timezone: timezone, localTimeOffset: localOffset, remoteTimeOffset: remoteOffset});
    }
  },
  mutations: {
    loginSuccess(state, userInfo) {
      state.loggedIn = userInfo.isOk;
      state.user = userInfo.data;
      state.permissions = userInfo.data.permissions;
      state.sites = userInfo.data.sites;
    },
    loginFailure(state) {
      state.loggedIn = false;
      state.user = null;
      state.permissions = [];
      state.sites = [];
    },
    logout(state, userInfo) {
      state.loggedIn = userInfo.isOk;
      state.user = userInfo.data;
      state.permissions = [];
      state.sites = [];
    },
    updateAuth(state, userInfo) {
      state.user.sessionId = userInfo.sessionId;
      state.user.accessToken = userInfo.accessToken;
      state.user.expiryDate = userInfo.expiryDate;
    },
    uptateTimezone(state,time){
      state.timezone = time.timezone
      state.localTimeOffset = time.localTimeOffset
      state.remoteTimeOffset = time.remoteTimeOffset
    }
  }
});




